import { ASK_AI_SETTINGS_PATH, askAiSettingsAPI } from '@lumapps/ask-ai/api';

import { DEFAULT_SORT_ORDER, RULES_LIST_MAX_RESULTS } from '../constants';
import { ListRulesParamsDTO, AskAiRule, RulesListDTO, RulePostDTO, RulePutDTO, CreateOrUpdateRuleDTO } from '../types';
import { isExistingRule } from '../utils';

export const listAskAiRules = async (params: ListRulesParamsDTO, signal?: AbortSignal) => {
    const { status, ...otherParams } = params;

    const { data } = await askAiSettingsAPI.get<RulesListDTO>('rules', {
        params: {
            maxResults: params.maxResults || RULES_LIST_MAX_RESULTS,
            /** map the given status array to a string of statuses separated by a comma */
            status: status ? status.map((currentStatus) => currentStatus.toLowerCase()).join(',') : undefined,
            sort: params.sort || DEFAULT_SORT_ORDER,
            ...otherParams,
        },
        signal,
    });

    return data;
};

export const getAskAiRule = async (ruleId: AskAiRule['id']) => {
    const { data } = await askAiSettingsAPI.get<AskAiRule>(`rules/${ruleId}`);
    return data;
};

export const deleteAskAiRules = async (ruleId: AskAiRule['id']) => askAiSettingsAPI.delete(`rules/${ruleId}`);

export const createAskAiRule = async (rule: RulePostDTO) => askAiSettingsAPI.post<RulePostDTO>('rules', rule);

export const updateAskAiRule = async (rule: RulePutDTO) => askAiSettingsAPI.put<RulePutDTO>(`rules/${rule.id}`, rule);

export const createOrUpdateRule = async (rule: CreateOrUpdateRuleDTO) =>
    isExistingRule(rule) ? updateAskAiRule(rule) : createAskAiRule(rule);

export const askAiRulesQueryKeys = {
    all: () => [ASK_AI_SETTINGS_PATH, 'rules'] as const,
    rules: (params?: ListRulesParamsDTO) => [...askAiRulesQueryKeys.all(), 'entities', params] as const,
    rule: (ruleId?: AskAiRule['id']) => [...askAiRulesQueryKeys.all(), ruleId] as const,
};
